/**
 * Stack Profile Service
 */

import api from './api';

// Stack Profile CRUD
export const getStackProfiles = async (params = {}) => {
  const response = await api.get('/stack-profiles/', { params });
  return response.data;
};

export const getStackProfile = async (profileId) => {
  const response = await api.get(`/stack-profiles/${profileId}`);
  return response.data;
};

export const createStackProfile = async (data) => {
  const response = await api.post('/stack-profiles/', data);
  return response.data;
};

export const updateStackProfile = async (profileId, data) => {
  const response = await api.put(`/stack-profiles/${profileId}`, data);
  return response.data;
};

export const deleteStackProfile = async (profileId) => {
  const response = await api.delete(`/stack-profiles/${profileId}`);
  return response.data;
};

// Auto-detection
export const detectStackFromRepo = async (data) => {
  const response = await api.post('/stack-profiles/detect', data);
  return response.data;
};

// Rule packs
export const getProfileRulePacks = async (profileId) => {
  const response = await api.get(`/stack-profiles/${profileId}/rule-packs`);
  return response.data;
};

// Dashboard
export const getStackProfileDashboard = async () => {
  const response = await api.get('/stack-profiles/dashboard/stats');
  return response.data;
};

// Options
export const getLanguages = async () => {
  const response = await api.get('/stack-profiles/options/languages');
  return response.data;
};

export const getFrameworks = async (language = null) => {
  const params = language ? { language } : {};
  const response = await api.get('/stack-profiles/options/frameworks', { params });
  return response.data;
};

export const getDatabases = async () => {
  const response = await api.get('/stack-profiles/options/databases');
  return response.data;
};

export const getMessageBuses = async () => {
  const response = await api.get('/stack-profiles/options/message-buses');
  return response.data;
};

export const getDeployments = async () => {
  const response = await api.get('/stack-profiles/options/deployments');
  return response.data;
};

// Constants for UI
export const LANGUAGE_COLORS = {
  nodejs: { bg: 'bg-green-100', text: 'text-green-800', badge: 'bg-green-500' },
  python: { bg: 'bg-blue-100', text: 'text-blue-800', badge: 'bg-blue-500' },
  java: { bg: 'bg-red-100', text: 'text-red-800', badge: 'bg-red-500' },
  dotnet: { bg: 'bg-purple-100', text: 'text-purple-800', badge: 'bg-purple-500' },
  go: { bg: 'bg-cyan-100', text: 'text-cyan-800', badge: 'bg-cyan-500' },
  php: { bg: 'bg-indigo-100', text: 'text-indigo-800', badge: 'bg-indigo-500' },
  ruby: { bg: 'bg-rose-100', text: 'text-rose-800', badge: 'bg-rose-500' },
  rust: { bg: 'bg-orange-100', text: 'text-orange-800', badge: 'bg-orange-500' },
  typescript: { bg: 'bg-sky-100', text: 'text-sky-800', badge: 'bg-sky-500' },
  other: { bg: 'bg-gray-100', text: 'text-gray-800', badge: 'bg-gray-500' }
};

export const DATABASE_ICONS = {
  postgresql: '🐘',
  mysql: '🐬',
  mongodb: '🍃',
  redis: '📕',
  sqlserver: '📊',
  elasticsearch: '🔍',
  dynamodb: '⚡'
};

export const DEPLOYMENT_COLORS = {
  kubernetes: 'bg-blue-500',
  docker: 'bg-sky-500',
  vm: 'bg-gray-500',
  serverless: 'bg-amber-500',
  'onprem-desktop': 'bg-slate-500'
};
